import(/* webpackMode: "eager" */ "/codebuild/output/src3458216674/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/global-error.tsx");
